import * as React from 'react';
import * as PropTypes from 'prop-types';
import { classNames, focusFirstFocusableChild } from '@progress/kendo-react-common';
/**
 * Represents the [KendoReact AppBarSection component]({% slug contentarrangement_appbar %}#toc-defining-sections).
 *
 * @example
 * ```jsx
 *
 * const App = () => {
 *   return (
 *       <AppBar>
 *           <AppBarSection>
 *               <span className="k-icon k-i-menu" />
 *           </AppBarSection>
 *
 *           <AppBarSpacer style={{ width: 8 }} />
 *
 *           <AppBarSection>
 *               <h1 className="title">{tc.text} AppBar</h1>
 *           </AppBarSection>
 *
 *           <AppBarSpacer />
 *
 *           <AppBarSection>
 *               <BadgeContainer>
 *                   <span className="k-icon k-i-bell" />
 *                   <Badge themeColor="info" shape="dot" />
 *               </BadgeContainer>
 *           </AppBarSection>
 *      </AppBar>
 *   );
 * };
 *    ReactDOM.render(<App />, document.querySelector('my-app'));
 * ```
 */
export var AppBarSection = React.forwardRef(function (props, target) {
    var children = props.children, className = props.className, style = props.style;
    var elementRef = React.useRef(null);
    var focusElement = React.useCallback(function () {
        if (elementRef.current) {
            focusFirstFocusableChild(elementRef.current);
        }
    }, []);
    var getImperativeHandle = React.useCallback(function () { return ({
        element: elementRef.current,
        focus: focusElement
    }); }, [focusElement]);
    React.useImperativeHandle(target, getImperativeHandle);
    var sectionClasses = React.useMemo(function () { return classNames('k-appbar-section', className); }, [className]);
    return (React.createElement("div", { className: sectionClasses, style: style }, children));
});
AppBarSection.propTypes = {
    children: PropTypes.any,
    className: PropTypes.string,
    style: PropTypes.object
};
AppBarSection.displayName = 'KendoAppBarSection';
//# sourceMappingURL=AppBarSection.js.map